import axios from 'axios';
import getAuthToken from '../utils/cookie';

export const getUserListingInCompany = async () => {
  const apiUrl = `${process.env.REACT_APP_BACKEND_URL}submission/all/user/listing/in/company/`;
  const tok = getAuthToken();
  const response = await axios.get(apiUrl, {
    headers: {
      Authorization: `Bearer ${tok}`
    }
  });
  return response;
};
